"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedDaysOfWeek = void 0;
const core_1 = require("../../../core");
const getDaysOfWeek_1 = require("./getDaysOfWeek");
const getSelectedDaysOfWeek = (days, t) => {
    const map = new Map([
        [core_1.DAY_OF_WEEK.monday, t('configurationBackup|dayOfWeek|monday')],
        [core_1.DAY_OF_WEEK.tuesday, t('configurationBackup|dayOfWeek|tuesday')],
        [core_1.DAY_OF_WEEK.wednesday, t('configurationBackup|dayOfWeek|wednesday')],
        [core_1.DAY_OF_WEEK.thursday, t('configurationBackup|dayOfWeek|thursday')],
        [core_1.DAY_OF_WEEK.friday, t('configurationBackup|dayOfWeek|friday')],
        [core_1.DAY_OF_WEEK.saturday, t('configurationBackup|dayOfWeek|saturday')],
        [core_1.DAY_OF_WEEK.sunday, t('configurationBackup|dayOfWeek|sunday')],
    ]);
    return getDaysOfWeek_1.getDaysOfWeek(days, map).join(', ');
};
exports.getSelectedDaysOfWeek = getSelectedDaysOfWeek;
//# sourceMappingURL=getSelectedDaysOfWeek.js.map